import { render, staticRenderFns } from "./IconFacebook.vue?vue&type=template&id=72d1093a&"
import script from "./IconFacebook.vue?vue&type=script&lang=ts&"
export * from "./IconFacebook.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports